export default "__VITE_ASSET__Cgf7cjDa__"